const endpoint = 'analytics/contained';
export const postContainedClassifieds = ({ analyticsData, bffUri }) => {
    void fetch([bffUri, endpoint].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
            type: 'CLASSIFIED_CONTAINED',
            subtype: 'CLASSIFIED_CARD_CONTAINED',
            source: 'SERP',
            ...analyticsData,
        }),
        signal: AbortSignal.timeout(2500),
    });
};
